<template>
  <div :class="{'search_show':show}" class="search">
    <span class="icon-sousuo search_icon" @click.stop="click"></span>
    <el-select ref="headerSearchSelect" v-model="search" filterable :placeholder="$ts('菜单导航搜索')" class="search_select" :remote-method="querySearch"
      filterable default-first-option remote clearable @change="change">
      <el-option v-for="item in options" :key="item.title.join(' > ')" :label="item.title.join(' > ')" :value="item">
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import {
    mapGetters,
  } from 'vuex';
  export default {
    name: 'HeaderSearch',
    data() {
      return {
        search: '',
        options: [],
        searchPool: [],
        show: false,
      }
    },
    computed: {
      ...mapGetters(['routes'])
    },
    watch: {
      show(value) {
        if (value) {
          document.body.addEventListener('click', this.close)
        } else {
          document.body.removeEventListener('click', this.close)
        }
      },
      routes(val) {
        this.searchPool = this.generateRoutes(this.routes)
      }
    },
    mounted() {
      this.searchPool = this.generateRoutes(this.routes);
    },
    methods: {
      click() {
        this.show = !this.show
        if (this.show) {
          this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.focus()
        }
      },
      close() {
        this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.blur()
        this.options = []
        this.show = false
      },
      change(val) {
        this.$router.push(val.path)
        this.search = ''
        this.options = []
        this.$nextTick(() => {
          this.show = false
        })
      },
      generateRoutes(routes, prefixTitle = []) {
        let res = []
        for (const router of routes) {
          if (!router) {
            continue
          }
          const data = {
            path: router.path || '',
            title: [...prefixTitle]
          }
          if(router.name){
            data.title = [...data.title, router.name]
          }
          if(router.path){
            res.push(data)
          }
          if (router.children) {
            const tempRoutes = this.generateRoutes(router.children, data.title)
            if (tempRoutes.length >= 1) {
              res = [...res, ...tempRoutes]
            }
          }
        }
        return res
      },
      querySearch(query) {
        if (query !== '') {
          this.options = this.searchPool.filter(item => item.title.join(' > ').indexOf(query) >= 0)
        } else {
          this.options = []
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search {
    &_icon {
      cursor: pointer;
      font-size: 18px;
      vertical-align: middle;
      font-family: 'iconfont';
    }

    &_select {
      font-size: 18px;
      transition: width 0.2s;
      width: 0;
      overflow: hidden;
      background: transparent;
      border-radius: 0;
      display: inline-block;
      vertical-align: middle;
    }

    &_show &_select {
      width: 160px;
      margin-left: 10px;
    }
  }
</style>

<style scoped>
  .search_select>>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 0;
    border: 0;
    padding-left: 0;
    padding-right: 0;
    box-shadow: none !important;
    border-bottom: 1px solid #d9d9d9;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/HeaderSearch.vue